import {addDeepLink} from 'app/components/textWithImageSSR/utils/addDeepLink';
import {addLazyScroll} from 'app/components/textWithImageSSR/utils/addLazyScroll';
import {ShouldSkipLazyLoadFn, ShouldSkipLazyLoadType} from 'app/interface';
import {getLoadingType} from 'app/utils/initialize/getLoadingType';
import {pageLinkHashHasId} from 'app/utils/initialize/pageLinkHashHasId';
import {TableConfig} from 'interfaces/common/components/table/tableConfig';

export const shouldSkipLazyLoad: ShouldSkipLazyLoadFn<TableConfig> = ({config}) => {
    if (!config) {
        throw new Error('No config found for Table.');
    }

    const loadingTypes = new Set<ShouldSkipLazyLoadType>();
    if (addLazyScroll(config.cId, config.text)) {
        loadingTypes.add('LOAD_EAGER_WITH_SCROLL_TO');
    }

    addDeepLink(config.cId, config.text);

    const hasReferenceInLink = pageLinkHashHasId(config.cId);
    if (hasReferenceInLink) {
        loadingTypes.add('LOAD_EAGER');
    }

    return getLoadingType(loadingTypes);
};
